import { proNavigator } from "single-spa/react-app/ProNavigator";
import { getPageSettings } from "app/reducers/_reducers/pageSettingsReducer";

import * as routingActions from "../action_types/routing_action_types";
import {
    SET_CHOSEN_ITEMS,
    SET_CHOSEN_ITEMS_HEADER_DATA,
    TOGGLE_PINK_BADGE,
    SET_PAGE_TRANSITION,
} from "../action_types/routing_action_types";

const changePage = ({
    page,
    module,
    stateId,
    params,
    stateConfig,
}: {
    page: string;
    module: string;
    stateId: string;
    params: any;
    stateConfig: any;
}) => {
    return {
        type: routingActions.CURRENT_PAGE,
        page,
        module,
        stateId,
        params,
        stateConfig,
        pageTitleConfig: getPageSettings(stateConfig, params),
    };
};

const urlChange = ({ toParams, stateConfig }: { stateConfig: any; toParams: FixmeType }) => {
    return {
        type: routingActions.URL_CHANGE,
        params: toParams,
        pageTitleConfig: getPageSettings(stateConfig, toParams),
    };
};

export const chosenItemsChange = (chosenItems: FixmeType) => {
    return {
        type: SET_CHOSEN_ITEMS,
        chosenItems,
    };
};

const chosenItemsSetHeaderData = (items: FixmeType) => {
    return {
        type: SET_CHOSEN_ITEMS_HEADER_DATA,
        items,
    };
};

const addPinkBadge = (pinkBadgeTitle: string) => {
    return {
        type: TOGGLE_PINK_BADGE,
        pinkBadgeTitle,
    };
};

const hidePinkBadge = () => {
    return {
        type: TOGGLE_PINK_BADGE,
        pinkBadgeTitle: null,
    };
};

export const setIsPageTransitioning = (isPageTransitioning: boolean) => {
    return {
        type: SET_PAGE_TRANSITION,
        isPageTransitioning,
    };
};

export const applyCurrentPage = () => (dispatch: FixmeType, getState: FixmeType) => {
    const state = getState();

    // if page is not in transitioning mode, then do nothing to apply current page
    if (!state.routing.isPageTransitioning) {
        return;
    }

    // get current page state and params from swNavigator, and update current page
    const curState = proNavigator.current();
    const curParams = proNavigator.getParams();
    dispatch(
        changePage({
            page: curState.name ?? "",
            module: proNavigator.getCurrentModule(),
            stateId: curState.stateId ? curParams[curState.stateId] : "",
            params: curParams,
            stateConfig: curState,
        }),
    );
    dispatch(setIsPageTransitioning(false));
};
